function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.71429 2.57141C6.76714 2.57141 6 3.33855 6 4.2857V19.7143C6 20.6614 6.76714 21.4286 7.71429 21.4286H16.2857C17.2329 21.4286 18 20.6614 18 19.7143V17.1428H16.2857V18.8571H7.71429V5.14284H16.2857V6.85712H18V4.2857C18 3.33855 17.2329 2.57141 16.2857 2.57141H7.71429ZM14.5714 8.57141C13.6286 8.57141 12.8571 9.34284 12.8571 10.2857V17.1428L14.5714 15.4286H19.7143C20.6571 15.4286 21.4286 14.6571 21.4286 13.7143V10.2857C21.4286 9.34284 20.6571 8.57141 19.7143 8.57141H14.5714Z",
  fill: "#8B6DFF"
});

var SvgPush = function SvgPush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/push.0178673c.svg";
export { ForwardRef as ReactComponent };